module.exports = __webpack_public_path__ + "img/Darkimage.f46375ba.svg";